import {
  API_URL,
  SagaIterator,
  assertTotalSchema,
  call,
  createDoRequestAction,
  debug,
  put,
  request,
  takeEvery,
  v,
} from "../../lib";
import { doREQUEST_ERROR, doPROJECT_TAG_LIST_ADD, doREQUEST_COMPLETE } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_PROJECT_TAG_CREATE = "REQUEST_PROJECT_TAG_CREATE";
export const doREQUEST_PROJECT_TAG_CREATE = createDoRequestAction(REQUEST_PROJECT_TAG_CREATE);

export const requestProjectTagCreateActionCreators = {
  doREQUEST_PROJECT_TAG_CREATE,
};

export function* requestProjectTagCreate({ payload, setRequestResult }: any): SagaIterator {
  debug("saga*requestProjectTagCreate");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        tags: v
          .array()
          .items(
            v
              .object({
                color: v.string().hex().length(6).exist(),
                value: v.string().max(250).exist(),
              })
              .exist(),
          )
          .exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_TAG_CREATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { projectId, tags } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "POST",
    url: `${API_URL}/v1/web/project-tag-create`,
    accessToken,
    data: {
      projectId,
      tags,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_TAG_CREATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/project-tag-create",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doPROJECT_TAG_LIST_ADD({
      id: projectId,
      tagList: result.payload,
    }),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_TAG_CREATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* projectTagCreateSaga() {
  yield takeEvery(REQUEST_PROJECT_TAG_CREATE, requestProjectTagCreate);
}
